import { render } from "./DisplayElementOrderBonusDetailsPreview.vue?vue&type=template&id=6b5eac41&ts=true"
import script from "./DisplayElementOrderBonusDetailsPreview.vue?vue&type=script&lang=ts"
export * from "./DisplayElementOrderBonusDetailsPreview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__